angular.module('pitch.app')

.factory('Office', function(config, $resource) {
    return $resource(config.apiUri + '/user/offices/:id', {
        id: '@id'
    });
})

.factory('OfficesLoader', function(Office, LoaderFactory) {
    return function(params) {
        return new LoaderFactory(Office, params);
    };
})

;



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/services/Office.js